import { useContext } from "react";
import { RoomContext } from "../../RoomContext";
import Participant from "../Participants/Participant";
import "./Grid.css";

const ParticipantGrid = () => {
  const { room } = useContext(RoomContext);
  const participants = Array.from(room?.participants.values() ?? []);
  participants.push(room.localParticipant);
  return (
    <div className="participant-grid">
      {participants.map((participant) => (
        <Participant participant={participant} key={participant.identity} />
      ))}
    </div>
  );
};

export default ParticipantGrid;
